import { render, staticRenderFns } from "./LogsModal.vue?vue&type=template&id=c312a786&"
import script from "./LogsModal.vue?vue&type=script&lang=js&"
export * from "./LogsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports